import {FC, useContext, useEffect} from 'react';
import {useNavigate, useParams} from 'react-router-dom';
import {useRecoilState, useRecoilStateLoadable} from 'recoil';

import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import {Stack} from '@mui/system';
import KeyboardReturnIcon from '@mui/icons-material/KeyboardReturn';
import NotFoundErrorInsideComponent from '../../../../ui/not-found/NotFoundErrorInsideComponent';
import CompanyForm from './CompanyForm';
import Fallback from '../../../../ui/fallback/Fallback';

import {contactPersonsOfCompanyFamilyQuery} from '../../../../store/contact-person/selectors';

import {companyByIdQuery} from '../../../../store/company/selectors';
import {currentCompanyIdState} from '../../../../store/company/atoms';
import {EventBusContext} from '../../../../providers/EventBus';
import {ICompany} from '../../../../shared/types/company.types';

const Company: FC = () => {
  const {id} = useParams();
  const [companyId, setCompanyId] = useRecoilState(currentCompanyIdState);
  const [{state: contactPersonsState, contents: contactPersonsContents}, setContactPersons] = useRecoilStateLoadable(
    contactPersonsOfCompanyFamilyQuery(id),
  );
  const [{state: companyState, contents: companyContents}, setCompany] = useRecoilStateLoadable(companyByIdQuery(id));
  const {bus} = useContext(EventBusContext);

  const navigate = useNavigate();

  console.log(
    'contactPersonsState',
    contactPersonsState,
    'companyState',
    companyState,
    contactPersonsContents,
    companyState,
  );
  const loading =
    contactPersonsState === 'loading' || companyState === 'loading' || !contactPersonsContents || !companyState;

  useEffect(() => {
    contactPersonsState === 'hasValue' && setContactPersons(contactPersonsContents);

    companyState === 'hasValue' && setCompany(companyContents);

    contactPersonsState === 'hasError' && bus?.emit('error', [contactPersonsContents]);

    companyState === 'hasError' && bus?.emit('error', [companyContents]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [companyState, contactPersonsState]);

  useEffect(() => {
    !companyId && setCompanyId(id as string);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box sx={{width: '100%'}}>
      <Paper sx={{width: '90%', margin: '0 auto', mt: 4, mb: 4}}>
        <Box sx={{padding: 2}}>
          <Box sx={{borderBottom: 1, borderColor: 'divider'}}>
            <Stack direction="row" spacing={7}>
              <Button startIcon={<KeyboardReturnIcon />} onClick={() => navigate('/customers')}>
                Назад
              </Button>
            </Stack>
          </Box>
          {companyState === 'hasError' || contactPersonsState === 'hasError' ? (
            <Box sx={{position: 'relative', minHeight: 512}}>
              <NotFoundErrorInsideComponent to="/clients" />
            </Box>
          ) : loading ? (
            <Box sx={{position: 'relative', minHeight: 512}}>
              <Fallback />
            </Box>
          ) : (
            <CompanyForm company={companyContents as ICompany} contactPersons={contactPersonsContents} />
          )}
        </Box>
      </Paper>
    </Box>
  );
};

export default Company;
